(function(){
  function initProductSection(section){
    if(!section) return;
    const select = section.querySelector('[data-lx-variant-select]');
    const idInput = section.querySelector('[data-lx-variant-id]');
    const price = section.querySelector('[data-lx-price]');
    const stickyId = document.querySelector('[data-lx-sticky-id]');
    const stickyPrice = document.querySelector('[data-lx-sticky-price]');
    if(!select || !idInput) return;

    select.addEventListener('change', function(){
      const option = select.options[select.selectedIndex];
      idInput.value = option.value;
      if(stickyId) stickyId.value = option.value;
      if(price && option.dataset.price) price.textContent = option.dataset.price;
      if(stickyPrice && option.dataset.price) stickyPrice.textContent = option.dataset.price;
    });
  }

  document.querySelectorAll('[data-lx-product-section]').forEach(initProductSection);
  document.addEventListener('shopify:section:load', function(e){ initProductSection(e.target); });
})();
